import * as React from 'react';
import { withStyles, createStyles, WithStyles } from '@material-ui/styles';

import { getConfig } from 'config/config';
import { useAppSelector } from 'store';
import { useLanguage } from 'languages/languageContext';

const { theme } = getConfig();

const styles = createStyles({
  text: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    padding: '0 1px',
    lineHeight: 1.6,
    color: theme.TEXT_SECONDARY,
    textAlign: 'center',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    // justifyContent: 'center',
    flexWrap: 'wrap',
    width: '100%',
    paddingHorizontal: 20,
  },
  link: {
    color: '#2671D1',
  },
});

interface Props extends WithStyles<typeof styles> {
  language?: any;
  type?: 'signUp' | 'otherInfo' | 'resetPassword' | 'info&email';
}

const Conditions: React.FC<Props> = ({ classes, type }) => {
  const { signUpDefault, signIn, global } = useLanguage();
  const {
    dpd_link,
    tou_link,
    registration_agb_checkbox,
    impressum,
    support_email,
    support_phone,
    support_name,
    support_phone_number,
  } = useAppSelector((state) => state.common);

  const descr0 = registration_agb_checkbox && type === 'signUp' ? signUpDefault.descr01 : signUpDefault.descr0;

  const SignUp = () => (
    <>
      {descr0}{' '}
      <a className={classes.link} href={tou_link} target="_blank" rel="noreferrer">
        {global.AGB}
      </a>{' '}
      {signUpDefault.descr1}{' '}
      <a className={classes.link} href={dpd_link} target="_blank" rel="noreferrer">
        {global.DSE}
      </a>{' '}
      {signUpDefault.descr2}{' '}
    </>
  );

  const Info = () => (
    <>
      {signIn.description0}{' '}
      <a className={classes.link} href={`mailto:${support_email}`}>
        {support_email}
      </a>{' '}
      {signIn.description1}{' '}
      <a className={classes.link} href={`tel:${support_phone.replaceAll(' ', '')}`}>
        {support_phone_number?.trim() ? support_phone_number : support_phone}{' '}
      </a>
      {support_name ? ` (${support_name}) ` : ''}
      {signIn.description2} |{' '}
      <a className={classes.link} href={impressum} target="_blank" rel="noreferrer">
        {global.impressum}
      </a>
      .
    </>
  );

  return (
    <div className="w-full flex flex-row">
      <div className={classes.textWrapper}>
        <div className={`${classes.text}`}>
          {type === 'resetPassword' &&
            (registration_agb_checkbox ? (
              <>
                {global.withCheckbox}{' '}
                <a className={classes.link} href={tou_link} target="_blank" rel="noreferrer">
                  {global.tou}
                </a>{' '}
                /{' '}
                <a className={classes.link} href={dpd_link} target="_blank" rel="noreferrer">
                  {global.dse}
                </a>
                .
              </>
            ) : (
              <>
                {global.withoutCheckbox}{' '}
                <a className={classes.link} href={tou_link} target="_blank" rel="noreferrer">
                  {global.AGB}
                </a>{' '}
                /{' '}
                <a className={classes.link} href={dpd_link} target="_blank" rel="noreferrer">
                  {global.DSE}
                </a>
                .
              </>
            ))}
          {type === 'signUp' && <SignUp />}
          {type === 'otherInfo' && (
            <>
              {!registration_agb_checkbox && <SignUp />}
              <Info />
            </>
          )}
          {type === 'info&email' && (
            <>
              <SignUp />
              <Info />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Conditions);
